/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { IDefinition } from '../../../core/models/common/IDefinition';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas30Visitor } from '../visitors/IOas30Visitor';
import { Oas30Header } from './Oas30Header';

/**
 * Constructor.
 * @param {string} name
 * @class
 * @extends Oas30Header
 * @author eric.wittmann@gmail.com
 */
export class Oas30HeaderDefinition extends Oas30Header implements IDefinition {
    public constructor(name : string) {
        super(name);
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasHeader#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas30Visitor = <IOas30Visitor><any>visitor;
        viz.visitHeaderDefinition(this);
    }
}
Oas30HeaderDefinition["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30HeaderDefinition";
Oas30HeaderDefinition["__interfaces"] = ["io.apicurio.datamodels.core.models.common.IDefinition","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.INamed"];




